import { ConnectionStatusType } from "@/types"
import Cookies from "js-cookie"
import { z } from "zod"

import { getClientId } from "../auth"
import { apiFetch, formatDate } from "../utils"
import { postActivityLog } from "./log"

const billingUrl = `himo-billing/`

//This endpoint used to create new connection status
export async function addConnectionStatus(data: ConnectionStatusType) {
  const token = Cookies.get("auth-token")

  if (token) {
    const response = await apiFetch(`${billingUrl}connection-status/`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    if (!response.ok) {
      await postActivityLog({
        menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
        sub_menu_path: "/meter-connection-settings/connection-status",
        action: "Add Connection Status",
        status_code: response.status,
        api_endpoint: response.url,
        web_url: window.location.href,
      })

      throw new Error(`Error: ${response.statusText}`)
    }

    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/connection-status",
      action: "Add Connection Status",
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    return response.json()
  }

  return null
}

//Used to Edit/Update Connection Status
export async function editConnectionStatus(
  connectionStatusId: number,
  data: ConnectionStatusType,
) {
  const token = Cookies.get("auth-token")

  if (token) {
    const response = await apiFetch(
      `${billingUrl}connection-status/${connectionStatusId}/`,
      {
        method: "PUT",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      },
    )
    if (!response.ok) {
      await postActivityLog({
        menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
        sub_menu_path: "/meter-connection-settings/connection-status",
        action: "Update Connection Status",
        status_code: response.status,
        api_endpoint: response.url,
        web_url: window.location.href,
      })

      throw new Error(`Error: ${response.statusText}`)
    }

    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/connection-status",
      action: "Update Connection Status",
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    return response.json()
  }

  return null
}
//this endpoint use to delete/remove connection status
export async function deleteConnectionStatus(id: number) {
  const response = await apiFetch(`${billingUrl}connection-status/${id}/`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/connection-status",
      action: `Delete Connection Status (ID ${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
    sub_menu_path: "/meter-connection-settings/connection-status",
    action: `Delete Connection Status (ID ${id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  if (response.status === 204) {
    return null
  }

  const contentType = response.headers.get("content-type")
  if (contentType && contentType.includes("application/json")) {
    return response.json()
  } else {
    return null
  }
}
